import { IConfig } from '../types';
import data from '../data/content.json'

const env = process.env.NODE_ENV;

const getIsUPC = () => {
  return process.env.REACT_APP_ENV === 'upc';
};

const getCountryCode = () => {
  const localeId =  document.getElementById('root').getAttribute('data-locale');
  return data.filter(
      (locale) => locale.lang === localeId
  )[0].linkCode;
}

const getOCAPIHost = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'store-staging.ubi.com';
  }

  return window.location.host;
};

const getLang = () => document.documentElement.getAttribute('lang');

const CONFIG: IConfig = {
  isUPC: getIsUPC(),
  countryCode: getCountryCode(),
  lang: getLang(),
  apiHost: getOCAPIHost(),
};
export default CONFIG;
